import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box, Grid } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InfoIcon from '@mui/icons-material/Info';
import ScorpRender2 from '../../../Image/ScorpRender2.png';

const BntScorpyos = () => {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const InfoBox = ({ title, children }) => (
    <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 2 }}>
      <Box
        sx={{
          width: 32,
          height: 32,
          borderRadius: '50%',
          bgcolor: '#A0C8DF',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mr: 1.5,
          flexShrink: 0,
        }}
      >
        <CheckCircleIcon sx={{ color: '#F47921', fontSize: 20 }} />
      </Box>
      <Box>
        <Typography sx={{ fontSize: '15px', fontWeight: 'bold', mb: 1 }}>{title}</Typography>
        <Typography sx={{ ml: 0 }}>{children}</Typography>
      </Box>
    </Box>
  );

  return (
    <div>
      <Button
        size="small"
        onClick={handleClickOpen}
        sx={{
          textTransform: 'none',
          color: '#2b8cb9',
          width: '15%',
          height: '15%',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <InfoIcon />
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        sx={{
          '& .MuiDialog-paper': {
            overflow: 'hidden',
            width: '100%',
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: 'bold',
            fontFamily: 'Open Sans',
            justifyContent: 'center',
            alignItems: 'center',
            display: 'flex',
            fontSize: '24px',
          }}
        >
          Scorpyos
        </DialogTitle>

        <DialogContent
          sx={{
            padding: 3,
            overflowY: 'auto',
            maxHeight: '70vh',
          }}
        >

            {/* Imagem abaixo */}
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            <img
              src={ScorpRender2}
              alt="Scorpyos Render"
              style={{ width: '60%', height: '60%' }}
            />
          </Box>
          {/* Grid com duas colunas */}
          <Grid container spacing={3}>
            {/* Coluna 1 */}
            <Grid item xs={6}>
              <InfoBox title="Processing Power">
                • ARM Cortex M7 processor at 300 MHz
              </InfoBox>

              <InfoBox title="Memory">
                • 2048Kb Flash, 384Kb SRAM <br />
                • 32 MB External Flash
              </InfoBox>

              <InfoBox title="Front Panel Connectivity">
                • 4 RS-422 ports (one dedicated to configuration) <br />
                • 2 CAN interfaces <br />
                • 7 GPIO connections <br />
                • 4 Digital inputs (5V Logic Level) <br />
                • 4 Analog inputs (0V~5V) <br />
                • 1 SPI with 3 Slave Select lines
              </InfoBox>
            </Grid>

            {/* Coluna 2 */}
            <Grid item xs={6}>
              <InfoBox title="Back Plane Interfaces">
                • ADHA Standard P2 <br />
                • ADHA Standard P1 with CAN, I2C, Sync and GPIOs <br />
                • ADHA Backplane controller with PSON, RST, HMS and Sync signals
              </InfoBox>

              <InfoBox title="Power Budgets">
                • Less than 1.2 W <br />
                • Input with LCL protection (UVP/OVP/OTP) <br />
                • Input voltage: 12 V
              </InfoBox>

              <InfoBox title="Mechanical Budgets">
                • Size: 238.75mm x 112mm x 30.48mm <br />
                • Mass: 350 grams
              </InfoBox>
            </Grid>
          </Grid>

        
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose}>Close</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default BntScorpyos;
